import { createBehavior } from '@area17/a17-behaviors';

const tagreveal = createBehavior(
  'tagreveal',
  {
    handleTriggerClick(evt) {
      evt.preventDefault();
      this.$node.classList.add('tagreveal:is-open');
      if (this.$firstHiddenTag) {
        this.$firstHiddenTag.focus();
      }
    },
    handleMedia(evt) {
      if (evt.matches) {
      } else {
        this.$node.classList.remove('tagreveal:is-open');
      }
    },
  },
  {
    init() {
      this.$trigger = this.getChild('trigger');
      this.$firstHiddenTag = this.getChild('first-hidden-tag');
      if (this.$trigger) {
        this.$trigger.addEventListener('click', this.handleTriggerClick);
      }
    },
    destroy() {
      if (this.$trigger) {
        this.$trigger.removeEventListener('click', this.handleTriggerClick);
      }
    },
  }
);

export default tagreveal;
